module.exports = __webpack_public_path__ + "img/9.e9c3db2a.jpg";